import React, { useEffect, useState } from 'react'
import { Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useSearch } from '../../../contexts/SearchContext'
import HeaderSearchModal from './HeaderSearchModal'

const HeaderSearch: React.FC = () => {
  const { globalSearchText } = useSearch()
  const [open, setOpen] = useState(false)

  // Ctrl/Cmd + K opens the spotlight.
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setOpen(true)
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])

  return (
    <>
      <Input
        className="gt-header-search"
        prefix={<SearchOutlined />}
        suffix={<kbd className="gt-header-search-kbd">⌘K</kbd>}
        placeholder={globalSearchText || 'Search'}
        value={globalSearchText}
        readOnly
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            setOpen(true)
          }
        }}
      />
      <HeaderSearchModal
        open={open}
        onClose={() => setOpen(false)}
        initialQuery={globalSearchText}
      />
    </>
  )
}

export default HeaderSearch
